export default __webpack_public_path__ + "static/media/tio.cae08893.png";